module.exports = __webpack_public_path__ + "assets/img/media-capitol-news.a2d0d0c3.svg";